import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import TeachersTable from '../../components/teachers/TeachersTable';

const TeachersArchive = () => (<WrapperSection><GlobalBreadcrumbs /><TeachersTable isArchive /></WrapperSection>);
export default TeachersArchive;
